module.exports = $;


//////////////////
// WEBPACK FOOTER
// external "$"
// module id = 122
// module chunks = 13